import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useState } from "react";
import { Check, Loader2, Zap } from "lucide-react";

const PLANS = [
  { id: "free", name: "Free", price: "$0", limit: "50 actions / month", lookup: null, features: ["1 headquarters", "Hire unlimited agents", "Live simulation"] },
  { id: "starter", name: "Starter", price: "$9", limit: "500 actions / month", lookup: "starter_monthly", features: ["Everything in Free", "Autopilot schedules", "Priority AI"] },
  { id: "pro", name: "Pro", price: "$29", limit: "2,000 actions / month", lookup: "pro_monthly", features: ["Everything in Starter", "Meeting Room Sync", "Connect Gmail & Calendar"] },
];

export default function UpgradeModal({ open, onOpenChange, currentPlan }) {
  const [loading, setLoading] = useState(null);

  const upgrade = async (lookup) => {
    if (!lookup) return;
    setLoading(lookup);
    try {
      const { checkout_url } = await api.checkout(lookup);
      window.location.href = checkout_url;
    } catch {
      toast.error("Could not start checkout");
      setLoading(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0b0e14] border border-cyan-500/40 text-zinc-100 max-w-3xl shadow-[0_0_50px_rgba(0,240,255,0.18)]">
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-widest text-cyan-300 flex items-center gap-2"><Zap size={18} /> Upgrade your plan</DialogTitle>
          <DialogDescription className="text-zinc-500 font-mono text-xs">Raise your monthly action cap. Cancel anytime. Test card 4242 4242 4242 4242.</DialogDescription>
        </DialogHeader>
        <div className="grid sm:grid-cols-3 gap-3 mt-2">
          {PLANS.map((p) => {
            const current = p.id === currentPlan;
            return (
              <div key={p.id} data-testid={`plan-${p.id}`} className={`rounded-xl border p-4 flex flex-col ${p.id === "pro" ? "border-cyan-400/40 bg-cyan-500/[0.05]" : "border-white/10 bg-white/[0.02]"}`}>
                <div className="font-tactical font-bold uppercase tracking-wide text-lg">{p.name}</div>
                <div className="mt-1"><span className="font-display font-black text-2xl">{p.price}</span><span className="text-zinc-500 text-xs">/mo</span></div>
                <div className="text-[11px] font-mono text-cyan-300 mt-1">{p.limit}</div>
                <ul className="mt-3 space-y-1.5 flex-1">
                  {p.features.map((f) => <li key={f} className="flex items-start gap-1.5 text-xs text-zinc-400"><Check size={13} className="text-emerald-400 mt-0.5 shrink-0" /> {f}</li>)}
                </ul>
                <Button
                  data-testid={`upgrade-${p.id}`}
                  disabled={current || !p.lookup || loading === p.lookup}
                  onClick={() => upgrade(p.lookup)}
                  className={`mt-4 w-full font-tactical font-bold uppercase text-xs ${current ? "bg-white/5 text-zinc-500" : "bg-cyan-500 hover:bg-cyan-400 text-[#04070c]"}`}
                >
                  {current ? "Current plan" : loading === p.lookup ? <Loader2 size={14} className="animate-spin" /> : p.lookup ? "Upgrade" : "—"}
                </Button>
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
